// Custom Collections JavaScript

class CustomCollectionsSort {
  constructor() {
    this.sortBtn = document.getElementById('customCollectionsSortBtn');
    this.sortMenu = document.getElementById('customCollectionsSortMenu');

    if (!this.sortBtn || !this.sortMenu) return;

    this.init();
  }

  init() {
    // Toggle dropdown
    this.sortBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      this.toggleDropdown();
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!this.sortMenu.contains(e.target) && !this.sortBtn.contains(e.target)) {
        this.closeDropdown();
      }
    });

    // Keyboard accessibility
    this.sortBtn.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.toggleDropdown();
      }
    });

    // Close on Escape
    document.addEventListener('keyup', (e) => {
      if (e.key === 'Escape') {
        this.closeDropdown();
      }
    });
  }

  toggleDropdown() {
    const isActive = this.sortMenu.classList.contains('custom-collections__sort-menu--active');

    if (isActive) {
      this.closeDropdown();
    } else {
      this.openDropdown();
    }
  }

  openDropdown() {
    this.sortBtn.classList.add('custom-collections__sort-btn--active');
    this.sortMenu.classList.add('custom-collections__sort-menu--active');
  }

  closeDropdown() {
    this.sortBtn.classList.remove('custom-collections__sort-btn--active');
    this.sortMenu.classList.remove('custom-collections__sort-menu--active');
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CustomCollectionsSort();
  });
} else {
  new CustomCollectionsSort();
}
